import bannerImg from './banners/woman-helping-man-gym.jpg';


const onboarding = (t) => ({
    id: 'onboarding',
    title: t('templates.items.onboarding.title'),
    description: t('templates.items.onboarding.description'),
    indicatedFor: t('templates.audiences.onlineCommunities'),
    stepsCount: 2,
    questionsSummary: [
        t('templates.items.onboarding.summary.fullName'),
        t('templates.items.onboarding.summary.howFound'),
        t('templates.items.onboarding.summary.communityGoal'),
        t('templates.items.onboarding.summary.previousExperience'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,

    formData: {
        title: t('templates.items.onboarding.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.onboarding.form.about.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.onboarding.form.about.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.onboarding.form.about.fullName.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'choices',
                        label: t('templates.items.onboarding.form.about.howFound.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.onboarding.form.about.howFound.options.instagram') },
                                { id: 'opt-2', label: t('templates.items.onboarding.form.about.howFound.options.referral') },
                                { id: 'opt-3', label: t('templates.items.onboarding.form.about.howFound.options.youtube') },
                                { id: 'opt-4', label: t('templates.items.onboarding.form.about.howFound.options.other') },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: t('templates.items.onboarding.form.expectations.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.onboarding.form.expectations.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'text',
                        label: t('templates.items.onboarding.form.expectations.mainGoal.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'yes_no_maybe',
                        label: t('templates.items.onboarding.form.expectations.otherCommunities.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default onboarding;
